// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HomeController from "./home_controller"
application.register("home", HomeController)

import CategoriesController from "./categories_controller"
application.register("categories", CategoriesController)

import ChaptersController from "./chapters_controller"
application.register("chapters", ChaptersController)

import CompaniesController from "./companies_controller"
application.register("companies", CompaniesController)

import HandshakesController from "./handshakes_controller"
application.register("handshakes", HandshakesController)

import MembersController from "./members_controller"
application.register("members", MembersController)

import MembershipsController from "./memberships_controller"
application.register("memberships", MembershipsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ReferralsController from "./referrals_controller"
application.register("referrals", ReferralsController)

import ReportsController from "./reports_controller"
application.register("reports", ReportsController)

import UsersController from "./users_controller"
application.register("users", UsersController)